module.exports = __webpack_public_path__ + "static/media/PeacefulWarning.10a62d51.mp3";